import { sha256 } from '@noble/hashes/sha256';
import { bytesToHex } from '@noble/hashes/utils';

/**
 * Returns a stable hex hash of a capability set. Sorts the input first so
 * input order doesn't matter. Spec §4.3 specifies sha256 + sorted-array.
 */
export function hashCapabilities(capabilities: string[]): string {
  const sorted = [...capabilities].sort().join(',');
  return bytesToHex(sha256(new TextEncoder().encode(sorted)));
}
